<template>
  <div>
    <p v-if="checking" role="status">กำลังตรวจสอบสิทธิ์ผู้ดูแลระบบ…</p>
    <p v-else-if="!allowed" role="alert" class="text-danger">{{ message }}</p>
    <slot v-else />
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { apolloClient } from '@/setup/apollo-setup'

export default {
  data() {
    return {
      checking: true,
      allowed: false,
      message: '',
      requestId: 0,
    }
  },
  watch: {
    '$store.state.currentUser': 'checkAccess',
    '$store.state.token': 'checkAccess',
  },
  created() {
    this.checkAccess()
  },
  beforeDestroy() {
    this.requestId++
  },
  methods: {
    async checkAccess() {
      const requestId = ++this.requestId
      this.allowed = false
      this.checking = true
      this.$emit('access', false)
      try {
        const result = await apolloClient.query({
          query: gql`
            query SystemRootAccess {
              systemRootAccess
            }
          `,
          fetchPolicy: 'no-cache',
        })
        if (requestId !== this.requestId) return
        this.allowed = !result.errors && result.data.systemRootAccess === true
        this.message =
          'ไม่มีสิทธิ์ใช้งานส่วนนี้ อนุญาตเฉพาะผู้ดูแลระบบที่มี Role Type เป็น root เท่านั้น'
        this.$emit('access', this.allowed)
      } catch (error) {
        if (requestId !== this.requestId) return
        this.message =
          'ไม่สามารถยืนยันสิทธิ์ได้ ส่วนนี้อนุญาตเฉพาะผู้ดูแลระบบที่มี Role Type เป็น root เท่านั้น กรุณาตรวจสอบการเข้าสู่ระบบหรือการเชื่อมต่อ'
      } finally {
        if (requestId === this.requestId) this.checking = false
      }
    },
  },
}
</script>
